import { typeCheckUtils } from '@zg-rentals/zillow-rental-manager/utils';

const AlertLink = ({ isBold = false, text = '', url = '' }) => ({
  isBold: Boolean(isBold),
  text: String(text),
  url: String(url),
});

type AlertLinkProps = ReturnType<typeof AlertLink>;

const Alert = ({ body = '', header = '', limit = '', links = null } = {}) => ({
  body: String(body),
  header: String(header),
  limit: String(limit),
  links: (links as Array<AlertLinkProps> | null)?.length
    ? (links as Array<AlertLinkProps> | null)?.map((link) => AlertLink(link))
    : null,
});

type AlertProps = ReturnType<typeof Alert>;

export type CriterionProps = {
  isEnabled: boolean;
  type: string;
  criterion: string;
  negotiable: boolean | null;
  min: string;
  max: string;
  alert?: AlertProps | null;
  refundable?: boolean | null;
};

const Criterion = ({
  isEnabled = false,
  type = '',
  criterion = '',
  negotiable = null,
  min = '',
  max = '',
  alert = null,
  refundable = null,
}: Partial<CriterionProps> = {}): CriterionProps => ({
  isEnabled: Boolean(isEnabled),
  type: String(type),
  criterion: String(criterion),
  negotiable: typeCheckUtils.Boolean(negotiable),
  min: String(min),
  max: String(max),
  alert: alert ? Alert(alert as never) : null,
  refundable: typeCheckUtils.Boolean(refundable),
});

export default Criterion;
